import React from "react";

/**
 * EditorialLabel — the small typographic marker that gives every major
 * section its "magazine number".
 *
 * Renders like:
 *
 *   ┌────────────────────────────────────────────────────────────┐
 *   │  N° 01 — TRAIL REPORT              42°26'N · 11°08'E       │
 *   └────────────────────────────────────────────────────────────┘
 *
 * Props:
 *   n         → issue/section number (string, "01" formatted).
 *   title     → the label text (uppercase).
 *   coords    → optional coordinates string; if omitted, uses ARGENTARIO default.
 *   accent    → tailwind class for the number tint (default: acid green).
 *   className → extra wrapper classes.
 */

export const ARGENTARIO_COORDS = "42°26'N · 11°08'E";

export default function EditorialLabel({
    n,
    title,
    coords = ARGENTARIO_COORDS,
    accent = "text-abnormal-acid",
    className = "",
}) {
    return (
        <div
            data-testid={`editorial-label-${(n || "").toString().toLowerCase()}`}
            className={`flex items-center justify-between gap-4 border-t border-b border-white/15 py-2 select-none ${className}`}
        >
            <span className="flex items-baseline gap-3 min-w-0">
                {n && (
                    <span className={`font-vt text-[11px] md:text-sm tracking-[0.25em] ${accent}`}>
                        N° {n}
                    </span>
                )}
                <span className="w-3 md:w-6 h-px bg-white/20" />
                <span className="font-vt text-[11px] md:text-sm tracking-[0.35em] uppercase text-abnormal-paper truncate">
                    {title}
                </span>
            </span>
            {coords && (
                <span className="hidden sm:inline font-vt text-[10px] md:text-sm tracking-[0.2em] text-abnormal-paperDim/70">
                    {coords}
                </span>
            )}
        </div>
    );
}
